import React from 'react'
import HeroSection from './HeroSection'

function NewLandingPage() {
    return (
        <div className="w-full min-h-screen bg-white">
            <HeroSection />
        </div>
    )
}

export default NewLandingPage